import React, { useState, useRef } from 'react';
import axiosInstance from '../../../../../util/AxiosInstance/AxiosInstance';
import { useCurrentEditor } from '@tiptap/react';
import styles from './ImageUpload.module.scss';

const ImageUpload = () => {
  const { editor } = useCurrentEditor();
  const [isUploading, setIsUploading] = useState(false);
  const [error, setError] = useState(null);
  const fileInputRef = useRef(null);

  const handleFileSelect = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validate file type
    if (!file.type.match(/image\/(jpeg|png|gif|webp)/)) {
      setError('Please upload a valid image file (JPEG, PNG, GIF, or WebP)');
      return;
    }

    // Validate file size (5MB limit)
    if (file.size > 5 * 1024 * 1024) {
      setError('Image size must be less than 5MB');
      return;
    }

    await uploadImage(file);
  };

  const uploadImage = async (file) => {
    setIsUploading(true);
    setError(null);

    const formData = new FormData();
    formData.append('image', file);

    try {
      const response = await axiosInstance.post('/upload/image', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      const data = response.data;
      // Use the full URL from the response
      const imageUrl = `${process.env.REACT_APP_BASE_URL}${data.imageUrl}`;

      // Insert the image into the editor with proper attributes
      editor
        .chain()
        .focus()
        .setImage({ 
          src: imageUrl,
          alt: file.name,
          title: file.name,
          class: 'tiptap-image',
          width: '50%',
          height: 'auto',
          style: 'display: block; margin: 1rem auto;'
        })
        .run();

    } catch (err) {
      setError('Failed to upload image. Please try again.');
      console.error('Image upload error:', err);
    } finally {
      setIsUploading(false);
      // Reset the file input
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
  };

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <div className={styles.imageUploadContainer}>
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileSelect}
        accept="image/jpeg,image/png,image/gif,image/webp"
        className={styles.fileInput}
      />
      <button
        onClick={handleClick}
        disabled={isUploading}
        className={styles.uploadButton}
      >
        {isUploading ? 'Uploading...' : 'Upload Image'}
      </button>
      {error && <div className={styles.error}>{error}</div>}
    </div>
  );
};

export default ImageUpload; 